export default {
    'id':'Id',
    'handle':'Handle',
    'type':'Type',
    'sex':'Anrede',
    'firstname':'Vorname',
    'lastname':'Nachname',
    'organisation':'Organisation',
    'street':'Strasse',
    'number':'Hausnummer',
    'postcode':'Postleitzahl',
    'city':'Stadt',
    'region':'Region / Bundesland',
    'country':'Land',
    'phone':'Telefon',
    'fax':'Fax',
    'email':'E-Mail',
    'idcard':'Personalausweisnummer',
    'idcardissuedate':'Ausstellungsdatum',
    'idcardauthority':'Ausstellende Behörde',
    'taxnr':'Steuernummer',
    'vatnr':'Umsatzsteuer-ID',
    'dateofbirth':'Geburtsdatum',
    'countryofbirth':'Geburtsland',
    'placeofbirth':'Geburtsort',
    'regionofbirth':'Region / Bundesland der Geburt',
    'registrationnumber': 'Firmennummer (HR-Nr.)',
    'created_at':'Erstellungsdatum',
    'updated_at':'Letzte Aktualisierung',
    'user':'Benutzer',
    'protection':'Schutz'

}



// WEBPACK FOOTER //
// ./src/lang/de/handle.js